import axios from "axios";
import { Cookies } from "react-cookie";
import { message } from "antd";
import { Constants } from "./settings";

const _cookies = new Cookies();

axios.defaults.headers.common["fcmToken"] = localStorage["fcmToken"]
  ? localStorage["fcmToken"]
  : "";
axios.defaults.baseURL = Constants.baseUrl;
axios.defaults.headers.common["Authorization"] = `Bearer ${
  _cookies.get("AccessToken") || ""
}`;

const handleError = (error = {}) => {
  switch (error.message) {
    case "Unauthorized":
      _cookies.remove("AccessToken", {
        path: "/",
        expires: new Date(1900, 1, 1),
        domain: window.location.hostname,
      });
      window.location = "/account/login";
      break;
    default:
      if (Array.isArray(error.message))
        error.message.forEach((text) => message.error(text));
      else if (error.message) message.error(error.message);
      break;
  }
};

const upload = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, { headers: { "content-type": "multipart/form-data" } })
      .then((response) => {
        if (response && response.data) {
          if (response.data.status === 1) {
            resolve(response.data);
          } else {
            handleError(response.data);
            reject(response.data);
          }
        }
      })
      .catch((error) => {
        handleError(error && error.response && error.response.data);
        reject(error && error.response && error.response.data);
      });
  });
};

const get = (url) => {
  return new Promise((resolve, reject) => {
    axios
      .get(url)
      .then((response) => {
        if (response && response.data) {
          resolve(response.data);
        }
      })
      .catch((error) => {
        handleError(error && error.response && error.response.data);
        reject(error && error.response && error.response.data);
      });
  });
};

const post = (url, params = {}, skip) => {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then((response) => {
        // if (response && response.data) {
        if (response && response.data) {
          if (skip || response.data.status === 1 || response.data.status == "success" || response.status == "success") {
            resolve(response.data);
          } else {
            handleError(response.data);
            reject(response.data);
          }
        }
      })
      .catch((error) => {
        handleError(error && error.response && error.response.data);
        reject(error && error.response && error.response.data);
      });
  });
};

const put = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    axios
      .put(url, params)
      .then((response) => {
        if (response && response.data) {
          if (response.data.status === 1 || response.data.status == "success") {
            resolve(response.data);
          } else {
            handleError(response.data);
            reject(response.data);
          }
        }
      })
      .catch((error) => {
        handleError(error && error.response && error.response.data);
        reject(error && error.response && error.response.data);
      });
  });
};

const del = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, params)
      .then((response) => {
        if (response && response.data) {
          if (response.data.status === 1 || response.data.status == "success" || response.data.status == true) {
            resolve(response.data);
          } else {
            handleError(response.data);
            reject(response.data);
          }
        }
      })
      .catch((error) => {
        handleError(error && error.response && error.response.data);
        reject(error && error.response && error.response.data);
      });
  });
};

export default {
  socialNetwork: {
    add: (params = {}) => {
      return post(`socialNetwork/panel/create`, params);
    },

    update: (params, id) => {
      return post(`socialNetwork/panel/update/${id}`, params);
    },
    delete: (id) => {
      return del(`socialNetwork/panel/delete/${id}`);
    },
    list: () => {
      return get("socialNetwork/panel/list");
    },

  },

  PRType: {
    add: (params = {}) => {
      return post(`p-r-type/panel/create`, params);
    },

    update: (params, id) => {
      return post(`p-r-type/panel/update/${id}`, params);
    },
    delete: (id) => {
      return del(`p-r-type/panel/delete/${id}`);
    },
    list: () => {
      return get("p-r-type/panel/list");
    },

    search: ( params = {}) => {
      let src = `p-r-type/panel/search?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      return get(src);
    },

  },

  color: {
    add: (params = {}) => {
      return post(`color/panel/create`, params);
    },

    update: (params, id) => {
      return post(`color/panel/update/${id}`, params);
    },
    delete: (id) => {
      return del(`color/panel/delete/${id}`);
    },
    list: () => {
      return get("color/panel/list");
    },
  },
  size: {
    add: (params = {}) => {
      return post(`size/panel/create`, params);
    },

    update: (params, id) => {
      return post(`size/panel/update/${id}`, params);
    },
    delete: (id) => {
      return del(`size/panel/delete/${id}`);
    },
    list: () => {
      return get("size/panel/list");
    },
  },
  userJobs: {
    add: (params = {}) => {
      return post(`userJobs/panel/create`, params);
    },

    update: (params, id) => {
      return post(`userJobs/panel/update/${id}`, params);
    },
    delete: (id) => {
      return del(`userJobs/panel/delete/${id}`);
    },
    list: () => {
      return get("userJobs/panel/list");
    },

  },
  baseLayoutSite: {
    add: (params = {}) => {
      return post(`baseLayoutSite/panel/create`, params);
    },

    update: (params, id) => {
      return post(`baseLayoutSite/panel/update/${id}`, params);
    },
    delete: (id) => {
      return del(`baseLayoutSite/panel/delete/${id}`);
    },
    list: () => {
      return get("baseLayoutSite/panel/list");
    },
    statusUpdate: (params = {}) => {
      return get(
        `baseLayoutSite/panel/changeStatus/${params._id}`
      );
    },

  },

  pointOfView: {
    add: (params = {}) => {
      return post(`pointOfView/panel/create`, params);
    },

    update: (params, id) => {
      return post(`pointOfView/panel/update/${id}`, params);
    },
    delete: (id) => {
      return del(`pointOfView/panel/delete/${id}`);
    },
    list: () => {
      return get("pointOfView/panel/list");
    },

    response: (params, id) => {
      return post(`pointOfView/panel/response/${id}`, params);
    },
    showInMainPage: (params = {}) => {
      return get(
        `pointOfView/panel/changeShowInMainPage/${params._id}`
      );
    },
  

  },

  slider: {
    add: (params = {}) => {
      return post(`slider/panel/create`, params);
    },

    update: (params, id) => {
      return post(`slider/panel/update/${id}`, params);
    },
    delete: (id) => {
      return del(`slider/panel/delete/${id}`);
    },
    list: (params = {}) => {
      // return get("slider/panel/list");

      let src = `slider/panel/list?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;


      return get(src);
    },

  },

  brand: {
    add: (params = {}) => {
      return post(`brand/store`, params);
    },
    delete: (id) => {
      return del(`brand/${id}/destroy`);
    },
    list: () => {
      return get("brand");
    },
    statusUpdate: (params = {}) => {
      return post(
        `brand/${params.id}/statusUpdate?status=${!!params.status ? 0 : 1}`
      );
    },
    update: (params, id) => {
      return post(`brand/${id}/update`, params);
    },
  },
  category: {
    add: (params = {}, id) => {
      return post(`category/panel/create`, params);
    },
    list: (params = {}) => {
      let src = `category/panel/list?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      if (params.type) src = `${src}&type=${params.type}`;

      if (params.parentId) src = `${src}&parentId=${params.parentId}`;

      if (params.category_type) src = `${src}&category_type=${params.category_type}`;

      return get(src);
    },
    statusUpdate: (params = {}) => {
      return get(
        `category/panel/changeStatus/${params._id}`
      );
    },
    delete: (params = {}) => {
      return del(`category/panel/delete/${params._id}`);
    },
    update: (params, id) => {
      return put(`category/panel/update/${id}`, params);
    },
  },
  store: {
    add: (params = {}) => {
      return post(`store`, params);
    },
    delete: (id = {}) => {
      return del(`store/panel/delete/${id}`);
    },
  },
  dashboard: {
    list: () => {
      return get("dashboard");
    },
  },
  message: {
    add: (params = {}) => {
      return post(`message/store`, params);
    },
    addDraft: (params = {}) => {
      return post(`draft/store`, params);
    },
    list: (params = {}) => {
      let src = `message?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      return get(src);
    },
    delete: (id) => {
      return del(`message/${id}/destroy`);
    },
    deleteDraft: (id) => {
      return del(`draft/${id}/destroy`);
    },
    draftList: (params = {}) => {
      let src = `draft?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      return get(src);
    },
    updateDraft: (params, id) => {
      return post(`draft/${id}/update`, params);
    },
  },
  offer: {
    add: (params = {}) => {
      return post(`special/store`, params);
    },
    list: (params = {}) => {
      let src = `special?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      if (params.startDate) src = `${src}&startDate=${params.startDate}`;

      if (params.endDate) src = `${src}&endDate=${params.endDate}`;

      return get(src);
    },
    statusUpdate: (params = {}) => {
      return post(
        `special/${params.id}/updateStatus?status=${
          !!parseInt(params.status) ? 0 : 1
        }`
      );
    },
    delete: (params = {}) => {
      return del(`special/${params.id}/destroy`);
    },
    update: (params, id) => {
      return post(`special/${id}/update`, params);
    },
  },
  order: {
    add: (params = {}) => {
      return post(`cart/store`, params);
    },
    delete: (id) => {
      return del(`cart/${id}/destroy`);
    },
    list: (params = {}) => {
      let src = `order/panel/list?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      if (params.endDate) src = `${src}&endDate=${params.endDate}`;

      if (params.orderType) src = `${src}&orderType=${params.orderType}`;

      if (params.payStatus) src = `${src}&paymentStatus=${params.payStatus}`;

      if (params.payType) src = `${src}&paymentType=${params.payType}`;

      if (params.startDate) src = `${src}&startDate=${params.startDate}`;

      if (params.status) src = `${src}&status=${params.status}`;

      return get(src);
    },
    changeStatus: (params, id) => {
      return post(`order/panel/changeStatus/${id}`, params);
    },
  },
  remittance: {

    list: (params = {}) => {
      let src = `remittance/list?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      if (params.endDate) src = `${src}&endDate=${params.endDate}`;

      if (params.startDate) src = `${src}&startDate=${params.startDate}`;


      return get(src);
    },

  },
  postman: {
    list: () => {
      return get("postman/getLocation");
    },
    report: (params = {}) => {
      return get(
        `postman/${params.id}/predictedDistance?fromDate=${params.fromDate}&toDate=${params.toDate}`
      );
    },
  },
  product: {
    addImage: (params = {}) => {
      return post(`store`, params);
    },
    list: (params = {}) => {
      let src = `product/panel/list?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;
      if (params.per_page) src = `${src}&per_page=${params.per_page}`;

      if (params.image) src = `${src}&image=${params.image}`;

      if (params.category) src = `${src}&category=${params.category}`;

      if (params.code) src = `${src}&code=${params.code}`;

      if (params.isVip) src = `${src}&isVip=${params.isVip}`;
      if (params.hasPrice) src = `${src}&hasPrice=${params.hasPrice}`;

      if (params.categoryId) src = `${src}&category_id=${params.categoryId}`;
      if (params.category_type) src = `${src}&category_type=${params.category_type}`;

      if (params.subCategoryId)
        src = `${src}&subCategory_id=${params.subCategoryId}`;

      return get(src);
    },

    baseList: (params = {}) => {
      let src = `product/panel/base_list_all?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;
      if (params.per_page) src = `${src}&per_page=${params.per_page}`;

      if (params.image) src = `${src}&image=${params.image}`;

      if (params.category) src = `${src}&category=${params.category}`;

      if (params.code) src = `${src}&code=${params.code}`;

      if (params.isVip) src = `${src}&isVip=${params.isVip}`;
      if (params.hasPrice) src = `${src}&hasPrice=${params.hasPrice}`;

      if (params.categoryId) src = `${src}&category_id=${params.categoryId}`;
      if (params.category_type) src = `${src}&category_type=${params.category_type}`;

      if (params.subCategoryId)
        src = `${src}&subCategory_id=${params.subCategoryId}`;

      return get(src);
    },

    searchSubList: (id, params = {}) => {
      let src = `product/panel/sub_list/${id}?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      return get(src);
    },

    searchBaseList: (id, params = {}) => {
      let src = `product/panel/base_list/${id}?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      return get(src);
    },

    statusUpdate: (params = {}) => {
      return post(
        `product/panel/changeStatus/${params._id}`
      );
    },

    basicUpdate: (params = {}) => {
      return post(
        `product/panel/changeBasic/${params._id}`
      );
    },
    delete: (params = {}) => {
      return del(
        `product/panel/delete/${params._id}`
      );
    },

    vipUpdate: (params = {}) => {
      return post(
        `product/${params.id}/VipUpdate?isVip=${
          !!parseInt(params.isVip) ? 0 : 1
        }`
      );
    },
    deleteImage: (id = {}) => {
      return del(`product/images/${id}/destroy`);
    },
    update: (params, id) => {
      return post(`product/panel/update/${id}`, params);
    },

    updateFeature: (params, id) => {
      return post(`product/panel/update/features/${id}`, params);
    },

    updateStock: (params, id) => {
      return post(`product/panel/update/stock/${id}`, params);
    },

    updateRelated: (params, id) => {
      return post(`product/panel/update/related/${id}`, params);
    },
    save: (params) => {
      return post(`product/panel/create`, params);
    },
    excelUpload: (params = {}) => {
      return post(`product/panel/upload/excel`, params);
    },

    setPRType: (params = {}) => {
      return post(
        `product/panel/setPRType/${params.id}`, params
      );
    },
  },
  question: {
    add: (params = {}) => {
      return post(`question/store`, params);
    },
    delete: (id) => {
      return del(`question/${id}/destroy`);
    },
    list: (params = {}) => {
      let src = `question?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      return get(src);
    },
    update: (params, id) => {
      return post(`question/${id}/update`, params);
    },
  },
  setting: {
    list: (type="") => {
      return get(`setting/panel/get/${type}`);
    },
    update: (params) => {
      return post(`setting/panel/create`, params);
    },
  },
  // slider: {
  //   add: (params = {}) => {
  //     return post(`slider/store`, params);
  //   },
  //   delete: (id) => {
  //     return del(`slider/${id}/destroy`);
  //   },
  //   list: (params = {}) => {
  //     let src = `slider?q=${params.q || ""}`;

  //     if (params.page) src = `${src}&page=${params.page}`;

  //     return get(src);
  //   },
  //   statusUpdate: (params = {}) => {
  //     return post(
  //       `slider/${params.id}/statusUpdate?status=${!!params.status ? 0 : 1}`
  //     );
  //   },
  //   update: (params, id) => {
  //     return post(`slider/${id}/update`, params);
  //   },
  // },
  tag: {
    add: (params = {}) => {
      return post(`tag/store`, params);
    },
    delete: (id) => {
      return del(`tag/${id}/destroy`);
    },
    list: (params = {}) => {
      let src = `tag?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      return get(src);
    },
    update: (params, id) => {
      return post(`tag/${id}/update`, params);
    },
  },
  package: {
    add: (params = {}, id) => {
      return post(`package/panel/create`, params);
    },
    delete: (id) => {
      return del(`package/panel/delete/${id}`);
    },
    list: (params = {}) => {
      let src = `package/panel/list?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;
      if (params.type) src = `${src}&type=${params.type}`;

      return get(src);
    },
    update: (params, id) => {
      return post(`package/panel/update/${id}`, params);
    },
  },
  user: {
    add: (userId, params = {}) => {
      return post(`users/panel/create`, params);
    },
    delete: (params = {}) => {
      return del(`users/panel/delete/${params._id}`);
    },
    details: (id) => {
      return get(`user/${id}`);
    },
    list: (params = {}) => {
      let src = `users/panel/list?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;
      if (params.user_type) src = `${src}&user_type=${params.user_type}`;

      if (params.level && params.level.length)
        params.level.forEach((o) => {
          src = `${src}&level[]=${o}`;
        });

      return get(src);
    },
    me: () => {
      return get("users/panel/info");
    },
    update: (userId, params) => {
      return put(`users/panel/update/${userId}`, params);
    },
    increaseCredit: (params = {}) => {
      return post(`user/${params.id}/chargeAccount`, params);
    },
    decreaseCredit: (params = {}) => {
      return post(`user/${params.id}/removalAccount`, params);
    },
    permissionUpdate: (params = {}) => {
      return post(`user/${params.id}/permissionUpdate`, params);
    },
    statusUpdate: (params = {}) => {
      return get(
        `users/panel/changeStatus/${params._id}`
      );
    },

    isAdminUpdate: (params = {}) => {
      return get(
        `users/panel/changeAdmin/${params._id}`
      );
    },
    vipUpdate: (params = {}) => {
      return put(
        `user/${params.id}/VipUpdate?isVip=${!!parseInt(params.isVip) ? 0 : 1}`
      );
    },
    login: (params = {}) => {
      return post("users/auth", params, true);
    },
    verify: (params = {}) => {
      return post("users/otp", params, true);
    },
  },
  voip: {
    distance: (params = {}) => {
      return post("location/getDistance", params);
    },
    user: (params = {}) => {
      return get(`voip/search?phone=${params.phone}`);
    },
    products: (params = {}) => {
      return post("voip/search/product", params);
    },
  },
  downloadApp: {
    list: () => {
      return get("downloadApp/list");
    },
    add: (params = {}) => {
      return post("downloadApp/save", params);
    },
    update: (params = {}) => {
      return post("downloadApp/update", params);
    },
    detail: {
      list: () => {
        return get("downloadApp/detail/list");
      },
      save: (params = {}) => {
        return post("downloadApp/detail/save", params);
      },
    },
  },
  deliveryTime: {
    list: (type={}) => {
      return get(`delivery-time/panel/list`);
    },
    add: (id="", params = {}) => {
      return post("delivery-time/panel/create", params);
    },
    delete: (id) => {
      return del(`delivery-time/panel/delete/${id}`);
    },
  },

  discount: {
    list: (type={}) => {
      return get(`discount/panel/list`);
    },
    add: (id="", params = {}) => {
      return post("discount/panel/create", params);
    },
    changeStatus: (id) => {
      return get(`discount/panel/change-status/${id}`);
    },

    delete: (id) => {
      return del(`discount/panel/delete/${id}`);
    },
  },

};
